import React from 'react';

export const Alert = (props) => {
    const { type, icon, content, iconSize, flex } = props;
    return (
        <div className={`alert alert-${type} my-2 text-center`}>
            {icon && <><i className={icon} style={{ fontSize: iconSize ? iconSize : "30px" }} /> </>}
            {!flex && <br />}
            <span>{content}</span>
        </div>
    );
}